import { fold } from './brief';
import { isForbiddenTitle } from './forbidden-product';

/**
 * Titles that are logistics / ops, not leisure day picks.
 * Shared by mini-planner Suggestions and any MCP day-suggest tool.
 */
const LOGISTICS_TITLE =
  /\b(vip\s*airport|airport\s*assist|airport\s*transfer|connection\s*flight|meet\s*(&|and)\s*greet|private\s*transfer\s*only|luggage\s*assist|fast\s*track\s*security)\b/i;

/**
 * Services sold on trips but not something a guest does on a day. Same set the
 * itinerary builder keeps out of its own picks (`GENERIC_TITLE_RE`).
 */
const SERVICE_TITLE =
  /\b(official\s+tourism\s+guide|flight\s+ticket|24\/7\s+contacts?|private\s+transfer|coordinator\b[^.]*\bassistance)\b/i;

/** @Suggestion / draft placeholders sometimes leak into catalogue. */
const PLACEHOLDER_TITLE = /^@\s*suggestion\b/i;

/**
 * Catalogue rows kept for history but flagged closed in the title: as a prefix
 * ("ENCERRADO: X"), a parenthetical ("X (Closed)"), a suffix ("X - Encerrado")
 * or a sentence ("fechado temporariamente", "permanently closed").
 */
const CLOSED_TITLE = new RegExp(
  [
    String.raw`^(encerrado|cerrado|closed|ferm[eé]|geschlossen|закрыто)\s*[:\-–]`,
    String.raw`\(\s*(encerrado|cerrado|closed|fechado|ferm[eé]|geschlossen)\b[^)]*\)`,
    String.raw`[-–—]\s*(encerrado|cerrado|closed|fechado)(\s+temporariamente)?\s*$`,
    String.raw`\b(temporarily|permanently)\s+closed\b`,
    String.raw`\b(fechado\s+temporariamente|encontra-se\s+fechado|fechado\s+para\s+obras)\b`,
  ].join('|'),
  'i'
);

export const isDaySuggestLogisticsNoise = (title: string): boolean => {
  const t = title.trim();
  if (!t) return true;
  if (PLACEHOLDER_TITLE.test(t)) return true;
  if (CLOSED_TITLE.test(t)) return true;
  // Never offered at all — not by any door (`forbidden-product.ts`).
  if (isForbiddenTitle(t)) return true;
  if (LOGISTICS_TITLE.test(t) || SERVICE_TITLE.test(t)) return true;
  const f = fold(t);
  if (f.includes('airport assistance')) return true;
  if (f.includes('connection flight')) return true;
  return false;
};
